/**
 * Scene modules each export `sceneMeta` (same name). Aliases below are required
 * because this file imports several scene modules in one scope.
 */
import { PulseScene, sceneMeta as pulseMeta, PULSE_SCENE_ID } from '../graphics/scenes/PulseScene.js';
import { WaveScene, sceneMeta as waveMeta, WAVE_SCENE_ID } from '../graphics/scenes/WaveScene.js';
import {
  IridescentWaveScene,
  sceneMeta as iridescentMeta,
  IRIDESCENT_WAVE_SCENE_ID,
} from '../graphics/scenes/IridescentWaveScene.js';
import {
  MarchingCubesScene,
  sceneMeta as marchingMeta,
  MARCHING_CUBES_SCENE_ID,
} from '../graphics/scenes/MarchingCubesScene.js';
import {
  CAHiFiCoreScene,
  sceneMeta as caHifiMeta,
  CA_HIFI_CORE_SCENE_ID,
} from '../graphics/scenes/CAHiFiCoreScene.js';

const ENTRIES = {
  [PULSE_SCENE_ID]: {
    meta: pulseMeta,
    create: () => new PulseScene(),
  },
  [WAVE_SCENE_ID]: {
    meta: waveMeta,
    create: () => new WaveScene(),
  },
  [IRIDESCENT_WAVE_SCENE_ID]: {
    meta: iridescentMeta,
    create: () => new IridescentWaveScene(),
  },
  [MARCHING_CUBES_SCENE_ID]: {
    meta: marchingMeta,
    create: () => new MarchingCubesScene(),
  },
  [CA_HIFI_CORE_SCENE_ID]: {
    meta: caHifiMeta,
    create: () => new CAHiFiCoreScene(),
  },
};

export function listSceneIds() {
  return Object.keys(ENTRIES);
}

/**
 * @param {string} id
 */
export function getSceneMeta(id) {
  return ENTRIES[id]?.meta ?? null;
}

/**
 * @param {string} id
 * @returns {import('../graphics/scenes/PulseScene.js').PulseScene | import('../graphics/scenes/WaveScene.js').WaveScene | import('../graphics/scenes/IridescentWaveScene.js').IridescentWaveScene | import('../graphics/scenes/MarchingCubesScene.js').MarchingCubesScene | import('../graphics/scenes/CAHiFiCoreScene.js').CAHiFiCoreScene | null}
 */
export function createScene(id) {
  const e = ENTRIES[id];
  return e ? e.create() : null;
}
